// Typing a time on a phone. iOS gives inputMode="numeric" a digits-only pad with no colon key, so these keep
// the number pad and place the colons themselves. Typed colons are dropped and re-placed, so desktop typing
// still works. (First fixed on the /joke race card, RacePlanCta.jsx; the free race page shares it now.)

// A marathon goal, left to right: the first digit is hours (no marathon goal reaches 10 h), then minutes,
// then seconds. "430" -> "4:30", "32959" -> "3:29:59".
export const formatGoalTime = (raw) => {
  const d = String(raw || '').replace(/\D/g, '').slice(0, 5);
  if (d.length <= 1) return d;
  if (d.length <= 3) return `${d[0]}:${d.slice(1)}`;
  return `${d[0]}:${d.slice(1, 3)}:${d.slice(3)}`;
};

// A recent race of any distance, right to left like a stopwatch: the last two digits are seconds, then
// minutes, then hours. "1930" -> "19:30" (a 5K), "14100" -> "1:41:00" (a half).
export const formatRaceTime = (raw) => {
  const d = String(raw || '').replace(/\D/g, '').replace(/^0+(?=\d{3})/, '').slice(0, 6);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, -2)}:${d.slice(-2)}`;
  return `${d.slice(0, -4)}:${d.slice(-4, -2)}:${d.slice(-2)}`;
};
